<template>
  <ProductDetailPageBase>
    <USConstructorWrapper>
      <ContainerProductDetailPageLayout>
        <template #breadcrumb>
          <ContainerBreadcrumb />
        </template>
        <template #out-of-stock>
          <ContainerOutOfStock />
        </template>
        <template #product-visuals>
          <ContainerProductDetailPageGallery />
        </template>
        <template #product-summary>
          <ContainerProductSummaryDesktop />
          <ContainerProductSummaryMobile />
          <ContainerDealSticker
            v-if="!isFlashSalesOnPDPEnabled"
            :class="{ 'mt-12': hasTelcoCalculator }"
          />
        </template>
        <template #product-aside-details>
          <ContainerAdvertisedPayment>
            <template #default="{ price, selectedOffer }">
              <USAdvertisedPayment :price :selected-offer />
            </template>
          </ContainerAdvertisedPayment>
          <ContainerCompatibleWith />

          <USContainerRefurbProcess>
            <template #shipping="{ merchant, shipping }">
              <USDeliveryPromiseCard :merchant :shipping />
            </template>
          </USContainerRefurbProcess>
          <ContainerSellerComment />
          <ContainerSeller />
        </template>
        <template #content>
          <div v-show="!isLpoActive">
            <USContainerReviewPhotosGuidance />
          </div>
        </template>
        <template #full-width-post-content>
          <ContainerRecommendations :hide-bundle-and-cross-sell="isLpoActive" />
          <ContainerCmsSection :index="1" />
          <ContainerReviews />
        </template>
        <template #full-width-seo-content>
          <ContainerCmsSection :index="2" />
          <ContainerSeoLinks />
          <ContainerCmsSection :index="3" />
          <ContainerCmsSection :index="4" />
          <ContainerSeoTechSpecs />
          <ContainerCmsSection :index="5" />
          <ContainerArticles />
          <AboutUs />
          <TrustListWrapper />
        </template>
        <template #modals>
          <component :is="ContainerPdpModals" />
        </template>
      </ContainerProductDetailPageLayout>
    </USConstructorWrapper>
  </ProductDetailPageBase>
</template>

<script setup lang="ts">
import { defineAsyncComponent } from 'vue'

import ProductDetailPageBase from '~/scopes/product-core/components/ProductDetailPageBase/ProductDetailPageBase.vue'
import ContainerAdvertisedPayment from '~/scopes/product-core/components/containers/ContainerAdvertisedPayment/ContainerAdvertisedPayment.vue'
import ContainerArticles from '~/scopes/product-core/components/containers/ContainerArticles/ContainerArticles.vue'
import ContainerBreadcrumb from '~/scopes/product-core/components/containers/ContainerBreadcrumb/ContainerBreadcrumb.vue'
import ContainerCmsSection from '~/scopes/product-core/components/containers/ContainerCmsSection/ContainerCmsSection.vue'
import ContainerCompatibleWith from '~/scopes/product-core/components/containers/ContainerCompatibleWith/ContainerCompatibleWith.vue'
import ContainerDealSticker from '~/scopes/product-core/components/containers/ContainerDealSticker/ContainerDealSticker.vue'
import ContainerOutOfStock from '~/scopes/product-core/components/containers/ContainerOutOfStock/ContainerOutOfStock.vue'
import ContainerProductDetailPageGallery from '~/scopes/product-core/components/containers/ContainerProductDetailPageGallery/ContainerProductDetailPageGallery.vue'
import ContainerProductSummaryDesktop from '~/scopes/product-core/components/containers/ContainerProductSummary/ContainerProductSummaryDesktop/ContainerProductSummaryDesktop.vue'
import ContainerProductSummaryMobile from '~/scopes/product-core/components/containers/ContainerProductSummary/ContainerProductSummaryMobile/ContainerProductSummaryMobile.vue'
import ContainerRecommendations from '~/scopes/product-core/components/containers/ContainerRecommendations/ContainerRecommendations.vue'
import ContainerReviews from '~/scopes/product-core/components/containers/ContainerReviews/ContainerReviews.vue'
import ContainerSeller from '~/scopes/product-core/components/containers/ContainerSeller/ContainerSeller.vue'
import ContainerSellerComment from '~/scopes/product-core/components/containers/ContainerSellerComment/ContainerSellerComment.vue'
import ContainerSeoLinks from '~/scopes/product-core/components/containers/ContainerSeoLinks/ContainerSeoLinks.vue'
import ContainerSeoTechSpecs from '~/scopes/product-core/components/containers/ContainerSeoTechSpecs/ContainerSeoTechSpecs.vue'
import ContainerProductDetailPageLayout from '~/scopes/product-core/components/containers/layouts/ContainerProductDetailPageLayout/ContainerProductDetailPageLayout.vue'
import AboutUs from '~/scopes/product-core/components/presentationals/AboutUs/AboutUs.vue'
import TrustListWrapper from '~/scopes/product-core/components/presentationals/TrustListWrapper/TrustListWrapper.vue'
import { useFlashSalesOnPDP } from '~/scopes/product-core/composables/useFlashSalesOnPDP/useFlashSalesOnPDP'
import { useGoogleShopping } from '~/scopes/product-core/composables/useGoogleShopping/useGoogleShopping'
import { useHasTelcoCalculator } from '~/scopes/product-core/composables/useHasTelcoCalculator/useHasTelcoCalculator'

import USAdvertisedPayment from './components/USAdvertisedPayment/USAdvertisedPayment.vue'
import USDeliveryPromiseCard from './components/USDeliveryPromiseCard/USDeliveryPromiseCard.vue'
import USConstructorWrapper from './components/containers/USConstructorWrapper/USConstructorWrapper.vue'
import USContainerRefurbProcess from './components/containers/USContainerRefurbProcess/USContainerRefubProcess.vue'
import USContainerReviewPhotosGuidance from './components/containers/USContainerReviewPhotosGuidance/USContainerReviewPhotosGuidance.vue'

const ContainerPdpModals = import.meta.client
  ? defineAsyncComponent(
      () =>
        import('~/scopes/product-core/components/containers/ContainerPdpModals/ContainerPdpModals.vue'),
    )
  : null

const { isLpoActive } = useGoogleShopping()
const isFlashSalesOnPDPEnabled = useFlashSalesOnPDP()
const hasTelcoCalculator = useHasTelcoCalculator()
</script>
